import { animated } from '@react-spring/web'
import React, { useState } from 'react'
import useMeasure from 'react-use-measure'
import { twMerge } from 'tailwind-merge'
import { ListQueryProps, Search, useIsMobile, useWindowSize } from '../../../..'
import { Modal } from '../../../Modal'

type Props = {
  isVisible: boolean
  label: string
  search?: boolean
  setVisible: any
  setSearchTerm: any
  className?: string
  children?: React.ReactNode
  listQueryProps?: ListQueryProps
}

export const OptionsPanel = ({ isVisible, setVisible, ...props }: Props) => {
  const isMobile = useIsMobile()
  const [isTypingOnMobile, setIsTypingOnMobile] = useState(false)
  const [height, width] = useWindowSize()
  const [windowRef, { height: windowHeight }] = useMeasure()
  const [searchRef, { height: searchHeight }] = useMeasure()
  const [optionsRef, { height: optionsHeight }] = useMeasure()

  function isMobileSafari() {
    const userAgent = navigator.userAgent

    // iOS detection
    const iOS = /iPad|iPhone|iPod/.test(userAgent)
    const webkit = !!userAgent.match(/WebKit/i)
    const isSafari =
      iOS && webkit && !userAgent.match(/CriOS/i) && !userAgent.match(/FxiOS/i)

    return isSafari
  }

  return (
    <Modal
      isOpen={isVisible}
      onClose={() => setVisible(false)}
      className={twMerge(
        `bg-white min-h-[200px] sm:min-h-full max-h-full`,
        props.className,
      )}
      title={props.label}
      type={
        props.search
          ? 'fullscreen-modal'
          : !isMobileSafari()
          ? 'bottom-panel'
          : 'top-panel'
      }>
      <div
        className='flex flex-col items-stretch grow overflow-hidden max-h-full'
        ref={windowRef}>
        {props.search && (
          <div className={`border-b border-gray-500 bg-white`}>
            <Search autoFocus onSearch={props.setSearchTerm} />
          </div>
        )}

        <animated.div
          className={`divide-y flex flex-col grow overflow-y-auto max-h-full`}>
          {props.children}
        </animated.div>
      </div>
    </Modal>
  )
}
